import { useEffect, useRef } from "react";
import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { AnimatePresence, motion } from "framer-motion";

import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Archive from "./pages/Archive";
import Portfolio from "./pages/Portfolio";
import Practice from "./pages/Practice";
import PracticeDetail from "./pages/PracticeDetail";
import ArtworkDetail from "./pages/ArtworkDetail";
import Objects from "./pages/Objects";
import ObjectDetail from "./pages/ObjectDetail";
import About from "./pages/About";
import AllCity from "./pages/AllCity";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";

const Page = ({ children }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollTop />
      {!isAdmin && <Nav />}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Page><Home /></Page>} />
          <Route path="/archive" element={<Page><Archive /></Page>} />
          <Route path="/portfolio" element={<Page><Portfolio /></Page>} />
          <Route path="/practice" element={<Page><Practice /></Page>} />
          <Route path="/practice/:slug" element={<Page><PracticeDetail /></Page>} />
          <Route path="/archive/:slug" element={<Page><ArtworkDetail /></Page>} />
          <Route path="/objects" element={<Page><Objects /></Page>} />
          <Route path="/objects/:slug" element={<Page><ObjectDetail /></Page>} />
          <Route path="/about" element={<Page><About /></Page>} />
          <Route path="/all-city" element={<Page><AllCity /></Page>} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={<Page><NotFound /></Page>} />
        </Routes>
      </AnimatePresence>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  const lenisRef = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App font-body" style={{ background: "var(--paper)" }}>
      <HelmetProvider>
        <BrowserRouter>
          <AnimatedRoutes />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
